import React from 'react';

export default function MenuArrowDownIcon(props) {
  return (
    <svg width={12} height={7} viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        id='Vector'
        d='M11.3683 1.04988L10.6983 0.379883L5.92828 5.14988L1.15829 0.379883L0.488281 1.04988L5.58828 6.14988L5.91828 6.46988L6.24828 6.14988L11.3483 1.04988H11.3683Z'
        fill='currentColor'
      />
    </svg>
  );
}
